import { Component, Injector, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AdaptClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";

@Component({
    selector: "adapt-coach-chat-page",
    standalone: false,
    templateUrl: "./coach-chat-page.component.html",
    styleUrl: "./coach-chat-page.component.css",
})
export class CoachChatPageComponent extends BaseRoutedComponent implements OnInit {
    public frameUrl?: SafeResourceUrl;

    public constructor(injector: Injector, sanitizer: DomSanitizer) {
        super(injector);

        this.frameUrl = sanitizer.bypassSecurityTrustResourceUrl(AdaptClientConfiguration.ChatbaseFrameUri);
    }

    public ngOnInit() {
        this.removeDefaultShellPadding();
        this.notifyActivated();
    }
}

export const coachChatPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-coach-chat-page", CoachChatPageComponent)
    .atOrganisationUrl("/coach-chat")
    .withTitle("Talk to our AI coach")
    .build();
